import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import findDuplicates from 'util/findDuplicates';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const validateConfig: ConfigValidationFunction<PipelineStepType.APPLY_COLUMN_MAPPING, 0> = (config) => {
  const nonEmptySystemNames = (config.outputColumns ?? [])
    .map((col) => col?.systemName)
    .filter((name): name is string => typeof name === 'string' && name !== '');

  const duplicates = findDuplicates(nonEmptySystemNames);
  const duplicateMsg =
    duplicates.length === 0 ? null : `System names must be unique. Duplicates: ${duplicates.join(', ')}`;

  return Helpers.coalesceMessages(duplicateMsg);
};

export default {
  stepType: PipelineStepType.APPLY_COLUMN_MAPPING,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.APPLY_COLUMN_MAPPING, 0>;
